module.exports = __webpack_public_path__ + "static/MtrHands-338af70fba8003ac854a803b0965182a.webp";